/**
 * @module ol/control/Panel
 */
import {Control} from 'ol/control'
import {CLASS_CONTROL, CLASS_UNSELECTABLE} from 'ol/css';

/**
 * @classdesc
 * A panel control
  * @api
 */
class ControlPanel extends Control {

  /**
   * @param {Options=} opt_options Panel options.
   */
  constructor(opt_options) {
    const options = opt_options ? opt_options : {};
    super({
      element:  options.element ?? document.createElement('div'),
      target: options.target,
    });

    this.subElements = this.subElements || {};

    const className =
      options.className !== undefined ?
        options.className :
          (options.side !== undefined ? "ol-panel-" + options.side :
            (options.direction !== undefined ? "ol-panel-" + options.direction : ''));

    this._baseClassName = className;

    const cssClasses =
      (options.side !== undefined ? 'ol-control-panel' : 'ol-panel') + ' ' + className + ' ' + CLASS_UNSELECTABLE; //CLASS_CONTROL;


    const element = this.element;
    element.className = cssClasses;

    if(options.subposition){
      this.addSubElement(options.subposition);
    }

    this.duration_ = options.duration !== undefined ? options.duration : 250;

    this.addCssProperty = !!(options?.addCssProperty ?? false);
  }

  getElement(subposition=null) {
    return subposition ? this.subElements[subposition] : this.element;
  }

  addSubElement(key){
    if(key && !this.subElements[key]){
      let subElement = document.createElement('div');
      subElement.className = key + ' ' + CLASS_UNSELECTABLE;
      this.element.appendChild(subElement);
      this.subElements[key] = subElement;
      this.setCssProperty();
    }
  }

  /**
   * @param {element} Element.
   */
  addElement(element) {
    let order = 1;
    let match = element.className.match(/order-(.+?) /);
    if(match && match.length==2){
      order = parseInt(match[1]);
    }
    let added = false;
    let childs = this.element.childNodes;
    for (var i = childs.length - 1; i >= 0; i--) {
      let child = childs[i];
      let className = childs[i].className;
      let match = className.match(/order-(.+?) /);
      let childOrder = 1;
      if(match && match.length==2){
        childOrder = parseInt(match[1]);
      }
      if(childOrder > order){
        this.element.insertBefore(element, child);
        added = true;
      }
    }

    if(!added){
      this.element.appendChild(element);
    }

    this.setCssProperty();
  }

  /**
   * @param {child} Element.
   */
  insertElementAtIndex (child, index) {
    this.element.appendChild(child);
    this.setCssProperty();
    return;

    // if (!index || index <= 0) {
    //   index = 1;
    // }
    // let el = this.element;
    // let num = el.children.length;
    // // console.log('ANTES:', index, num);
    // if(index > num){
    //   for (let i = 1; i <= Math.max(index, num); i++) {
    //     if(i > num){
    //       el.appendChild(document.createElement('div'));
    //     }else{
    //       // if(el.children[i].innerHTML.trim().length == 0){
    //       //   el.replaceChild(child, el.childNodes[i]);
    //       // }else{
    //       //   el.insertBefore(child, el.children[i])
    //       // }
    //     }
    //   }
    // }
    // console.log('DEPOIS:', index, el.children.length, el.children);

    // if (index >= el.children.length) {
    //   for (let i = el.children.length-1; i < index-1; i++) {
    //       var tableChild = children[i];
    //     }
    //     document.getElementById('foo').innerHTML.trim().length == 0
    // } else {
    //   el.appendChild(child);
    //   el.insertBefore(child, el.children[index])
    // }
  }

  /**
   * Clean up.
   * @override
   */
  disposeInternal() {
    super.disposeInternal();
    this.setCssProperty(true)
  }

  setCssProperty(reset = false) {
    if(this.addCssProperty) {
      const propertyName = `--${this._baseClassName}`;
      let doc = document.documentElement;
      if(reset) {
        doc.style.removeProperty(propertyName);
      }else{
        doc.style.setProperty(propertyName, `${this.element.clientHeight ?? 0}px`);
      }
    }
  }
}

export default ControlPanel;